import React from "react";
import { Route, Redirect } from "react-router-dom";

/**
 * Show when user is not signed in
 * otherwise, redirect to /dashboard
 * @param Component
 * @param {boolean} restricted - true meaning public route , false meaning protected route
 * @param props
 * @param isLoggedIn
 * @param res
 * @return {*}
 * @constructor
 */
const PublicRoute = ({
  component: Component,
  restricted,
  props,
  isLoggedIn,
  ...res
}) => {
  return (
    <Route
      {...res}
      render={(props) =>
        isLoggedIn ? <Redirect to={`/dashboard`} /> : <Component {...props} />
      }
    />
  );
};

export default PublicRoute;
